import type { Subscription } from '../types/subscription';

export class SubscriptionHelper {
  static hasAccessChanged(oldSubscription: Subscription, newSubscription: Subscription) {
    if (!oldSubscription || !newSubscription) {
      return false;
    }

    const statusChanged = oldSubscription.status !== newSubscription.status;
    const planChanged = oldSubscription.planCode !== newSubscription.planCode;

    return statusChanged || planChanged ? true : false;
  }
}
